export default __webpack_public_path__ + "static/shape-2bfa0297751f174659823b94fffde1ab.png";